{
  "username": "test@valuesyou.com",
  "status": "ACTIVE",
  "data": {
    "EMPLOYEE_ID": "123456",
    "EMAIL_ADDRESS": "",
    "FIRST_NAME": "Joseph",
    "SERVICE_LENGTH": "1.9",
    "ROLE_GROUP": "Admin",
    "TOTAL_COMPENSATION_AND_REWARDS": "211055.1323",
    "TOTAL_ANNUAL_COMPENSATION": "89000",
    "TOTAL_ANNUAL_REWARDS": "122055.1323",
    "TOTAL_HEALTH": "12571.68",
    "TOTAL_WEALTH": "13423.92",
    "TOTAL_PROTECTION": "889.80",
    "TOTAL_TIME": "4107.69",
    "MEDICAL_PLAN_TITLE": "Cigna $750 PPO OAP",
    "MEDICAL_EE": "2480.4",
    "MEDICAL_ER": "9809.52",
    "DENTAL_PLAN_TITLE": "MetLife Base Plan",
    "DENTAL_EE": "0",
    "DENTAL_ER": "167.28",
    "VISION_PLAN_TITLE": "VSP Base Plan",
    "VISION_EE": "37.92",
    "VISION_ER": "30.72",
    "EAP_ER": "45.84",
    "401K_EE": "5340",
    "401K_ER": "3560",
    "PROFIT_SHARING_ER": "4450",
    "HSA_FUND_LABEL": "",
    "HSA_FUND_EE": "",
    "HSA_FUND_ER": "",
    "FSA_HEALTHCARE_EE": "64.32",
    "FSA_DEPENDENT_CARE_EE": "9.6",
    "BASIC_TERM_LIFE_ER": "300",
    "BASIC_ADD_ER": "221.28",
    "STD_ER": "108",
    "LTD_ER": "",
    "VOL_TERM_LIFE_EE": "",
    "VOL_TERM_LIFE_PARTNER": "",
    "VOL_TERM_LIFE_CHILD": "",
    "LTC": "",
    "LEGAL_SERVICES_EE": "",
    "CRITICAL_ILLNESS_EE": "",
    "CRITICAL_ILLNESS_PARTNER": "",
    "CRITICAL_ILLNESS_CHILD": "",
    "HOSPITAL_IND_INS_LABEL": "Accident Insurance",
    "HOSPITAL_IND_INS_EE": "137.52",
    "ACCIDENTAL_INJURY_INS_LABEL": "",
    "ACCIDENTAL_INJURY_INS_EE": "",
    "BUSINESS_TRAVEL_ACCIDENT": "",
    "ID_THEFT_PROTECTION_LABEL": "Allstate ID Theft Employee",
    "ID_THEFT_PROTECTION_EE": "123",
    "PET_INSURANCE": "",
    "VACATION_DAYS": "12",
    "VACATION_PAY": "4107.692308",
    "SICK_TIME": "8.666666667",
    "BEREAVEMENT_LEAVE_DAYS": "5",
    "HOLIDAYS": "10",
    "CHARITABLE_VOLUNTEERING_DAYS": "",
    "CHARITABLE_VOLUNTEERING_VALUE": "",
    "2022_AP": "85000",
    "2022_AIP": "5000",
    "2022_PER_DIEM": "",
    "2023_AP": "89000",
    "2023_AIP": "2125",
    "2023_PER_DIEM": "",
    "2024_AP": "89000",
    "2024_AIP": "10556",
    "2024_PER_DIEM": "",
    "2025_AP": "1",
    "2025_AIP": "1",
    "2025_PER_DIEM": "1",
    "FOOD_DELIVERY_DISCOUNTS": "1",
    "FITNESS_DISCOUNTS": "1",
    "DAY_CARE_SUPPORT": "1",
    "FAMILY_BUILDING_SUPPORT": "1",
    "CAREER_DEVELOPMENT": "1",
    "TUITION_REIMBURSEMENT_ADMIN": "1",
    "MSA_FINANCIAL_WELLNESS": "1",
    "EMPLOYEE_GIVING": "1"
  },
  "groups": [],
  "permissions": [
    2
  ],
  "zones": [
    {
      "id": 1,
      "name": "Default"
    }
  ],
  "associates": [],
  "mfaEnabled": [],
  "zone": 1,
  "lastLogin": null
}
